import { useState } from "react";
import { Phone, Mail, MessageSquare, MapPin, Edit2, Trash2 } from "lucide-react";
import Modal from "../components/Modal";
import AtivacaoNosModulos from "../components/AtivacaoNosModulos";
import Badge from "../components/Badge";
import ConfirmDialog from "../components/ConfirmDialog";
import HistoryTimeline from "../components/HistoryTimeline";
import { corrigirContato } from "../lib/contatoEdit";
import { CLIENT_STAGES, FLEET_SIZES, SERVICES, LOSS_REASONS, REGIONS, CONTACT_CHANNELS } from "../constants";
import { fmt, fmtDate, fmtShort, getToday } from "../utils";
import Field, { inputStyle, selectStyle } from "../components/Field";

export default function ClientDetail({
  client, onClose, clients, setClients,
  moveClient, setShowNewInteraction, today,
  onDelete, contracts, satisfaction, onAdesao, userName = "",
}) {
  const [editing, setEditing] = useState(false);
  const [editData, setEditData] = useState({});
  const [showLossModal, setShowLossModal] = useState(false);
  const [lossReason, setLossReason] = useState("");
  const [lossOther, setLossOther] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showHistory, setShowHistory] = useState(false);

  if (!client) return null;

  const stage = CLIENT_STAGES.find((s) => s.id === client.stage);
  const fleet = FLEET_SIZES.find((f) => f.id === client.fleetSize);

  const startEdit = () => {
    setEditData({
      company: client.company, contact: client.contact, title: client.title,
      phone: client.phone, email: client.email, whatsapp: client.whatsapp,
      region: client.region, fleetSize: client.fleetSize,
      estimatedValue: client.estimatedValue || "",
      contractMonths: client.contractMonths || 12,
      notes: client.notes || "",
      nextAction: client.nextAction || "",
      nextActionDate: client.nextActionDate || "",
    });
    setEditing(true);
  };

  const saveEdit = () => {
    setClients((prev) => prev.map((c) =>
      c.id === client.id ? { ...c, ...editData, estimatedValue: parseInt(editData.estimatedValue) || 0 } : c
    ));
    setEditing(false);
    onClose();
  };

  const handleLoss = () => {
    const reason = lossReason === "Outro" ? lossOther : lossReason;
    if (!reason) return;
    setClients((prev) => prev.map((c) =>
      c.id === client.id ? {
        ...c, stage: "perdido", lossReason: reason,
        stageHistory: [...(c.stageHistory || []), { from: c.stage, to: "perdido", date: getToday(), note: `Motivo: ${reason}` }],
      } : c
    ));
    setShowLossModal(false);
    onClose();
  };

  const handleStageChange = (newStage) => {
    setClients((prev) => prev.map((c) =>
      c.id === client.id ? {
        ...c, stage: newStage,
        stageHistory: [...(c.stageHistory || []), { from: c.stage, to: newStage, date: getToday(), note: "" }],
      } : c
    ));
  };

  return (
    <>
      <Modal open={!!client} onClose={onClose} title="Detalhe do Lead — Cliente" w={660}>
        {editing ? (
          /* ── MODO EDIÇÃO ── */
          <div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 12px" }}>
              <div style={{ gridColumn: "1/-1" }}>
                <Field label="Empresa"><input style={inputStyle} value={editData.company} onChange={(e) => setEditData((p) => ({ ...p, company: e.target.value }))} /></Field>
              </div>
              <Field label="Contato"><input style={inputStyle} value={editData.contact} onChange={(e) => setEditData((p) => ({ ...p, contact: e.target.value }))} /></Field>
              <Field label="Cargo"><input style={inputStyle} value={editData.title} onChange={(e) => setEditData((p) => ({ ...p, title: e.target.value }))} /></Field>
              <Field label="Telefone"><input style={inputStyle} value={editData.phone} onChange={(e) => setEditData((p) => ({ ...p, phone: e.target.value }))} /></Field>
              <Field label="WhatsApp"><input style={inputStyle} value={editData.whatsapp} onChange={(e) => setEditData((p) => ({ ...p, whatsapp: e.target.value }))} /></Field>
              <Field label="E-mail"><input style={inputStyle} value={editData.email} onChange={(e) => setEditData((p) => ({ ...p, email: e.target.value }))} /></Field>
              <Field label="Região">
                <select style={selectStyle} value={editData.region} onChange={(e) => setEditData((p) => ({ ...p, region: e.target.value }))}>
                  {REGIONS.map((r) => <option key={r} value={r}>{r}</option>)}
                </select>
              </Field>
              <Field label="Frota">
                <select style={selectStyle} value={editData.fleetSize} onChange={(e) => setEditData((p) => ({ ...p, fleetSize: e.target.value }))}>
                  {FLEET_SIZES.map((f) => <option key={f.id} value={f.id}>{f.label}</option>)}
                </select>
              </Field>
              <Field label="Valor Estimado (R$)"><input style={inputStyle} type="number" value={editData.estimatedValue} onChange={(e) => setEditData((p) => ({ ...p, estimatedValue: e.target.value }))} /></Field>
              <Field label="Próx. Ação"><input style={inputStyle} value={editData.nextAction} onChange={(e) => setEditData((p) => ({ ...p, nextAction: e.target.value }))} /></Field>
              <Field label="Data Próx. Ação"><input style={inputStyle} type="date" value={editData.nextActionDate} onChange={(e) => setEditData((p) => ({ ...p, nextActionDate: e.target.value }))} /></Field>
              <div style={{ gridColumn: "1/-1" }}>
                <Field label="Observações"><textarea style={{ ...inputStyle, minHeight: 50, resize: "vertical" }} value={editData.notes} onChange={(e) => setEditData((p) => ({ ...p, notes: e.target.value }))} /></Field>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 6, marginTop: 8 }}>
              <button onClick={() => setEditing(false)} style={{ padding: "7px 14px", borderRadius: 6, border: "1px solid #e2e8f0", background: "#fff", color: "#64748b", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Cancelar</button>
              <button onClick={saveEdit} style={{ padding: "7px 14px", borderRadius: 6, border: "none", background: "#0d9488", color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Salvar Alterações</button>
            </div>
          </div>
        ) : (
          /* ── MODO VISUALIZAÇÃO ── */
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
              <div>
                <div style={{ fontSize: 18, fontWeight: 800, color: "#0f172a" }}>{client.company}</div>
                <div style={{ fontSize: 13, color: "#64748b" }}>{client.contact} — {client.title}</div>
              </div>
              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <Badge color={stage?.color}>{stage?.label}</Badge>
                <button onClick={startEdit} style={{ background: "none", border: "none", cursor: "pointer", color: "#64748b", padding: 2 }} title="Editar"><Edit2 size={14} /></button>
                <button onClick={() => setShowDeleteConfirm(true)} style={{ background: "none", border: "none", cursor: "pointer", color: "#ef4444", padding: 2 }} title="Excluir"><Trash2 size={14} /></button>
              </div>
            </div>

            {/* Stage bar */}
            <div style={{ display: "flex", gap: 2, marginBottom: 14 }}>
              {CLIENT_STAGES.filter((s) => !["ganho", "perdido", "descartado"].includes(s.id)).map((s) => {
                const ci = CLIENT_STAGES.findIndex((x) => x.id === s.id);
                const di = CLIENT_STAGES.findIndex((x) => x.id === client.stage);
                return (
                  <button key={s.id} onClick={() => handleStageChange(s.id)}
                    style={{ flex: 1, height: 6, borderRadius: 3, border: "none", background: ci <= di ? stage?.color : "#e2e8f0", cursor: "pointer", padding: 0 }}
                    title={`${s.label} — ${s.help}`} />
                );
              })}
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 14 }}>
              <div style={{ padding: 10, borderRadius: 7, background: "#f8fafc", textAlign: "center" }}>
                <div style={{ fontSize: 11, color: "#64748b" }}>Frota</div>
                <div style={{ fontSize: 14, fontWeight: 700 }}>{fleet?.label || "—"}</div>
              </div>
              <div style={{ padding: 10, borderRadius: 7, background: "#f8fafc", textAlign: "center" }}>
                <div style={{ fontSize: 11, color: "#64748b" }}>Valor Estimado</div>
                <div style={{ fontSize: 14, fontWeight: 700 }}>{client.estimatedValue ? fmt(client.estimatedValue) : "—"}</div>
              </div>
              <div style={{ padding: 10, borderRadius: 7, background: "#f8fafc", textAlign: "center" }}>
                <div style={{ fontSize: 11, color: "#64748b" }}>Contrato</div>
                <div style={{ fontSize: 14, fontWeight: 700 }}>{client.contractMonths || 12} meses</div>
              </div>
            </div>

            {/* Contact info */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, marginBottom: 14 }}>
              {[
                { icon: <Phone size={12} />, text: client.phone },
                { icon: <Mail size={12} />, text: client.email },
                { icon: <MessageSquare size={12} />, text: client.whatsapp ? `WA: ${client.whatsapp}` : "—" },
                { icon: <MapPin size={12} />, text: client.region },
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, padding: "6px 10px", borderRadius: 6, background: "#f8fafc", fontSize: 11, color: "#475569" }}>
                  <span style={{ color: "#0d9488" }}>{item.icon}</span>{item.text || "—"}
                </div>
              ))}
            </div>

            {/* Services & vehicle types */}
            <div style={{ display: "flex", gap: 3, flexWrap: "wrap", marginBottom: 8 }}>
              {client.vehicleTypes?.map((v) => <Badge key={v} color="#2563eb" small variant="outline">{v}</Badge>)}
              {client.services?.map((s) => <Badge key={s} color="#0d9488" small>{SERVICES.find((x) => x.id === s)?.label || s}</Badge>)}
            </div>

            {/* Next action */}
            {client.nextAction && !["ganho", "perdido", "descartado"].includes(client.stage) && (
              <div style={{
                padding: "10px 14px", borderRadius: 8, marginBottom: 14,
                background: client.nextActionDate < today ? "#fef2f2" : "#f0fdfa",
                border: `1px solid ${client.nextActionDate < today ? "#fecaca" : "#99f6e4"}`,
              }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: client.nextActionDate < today ? "#991b1b" : "#0f4f46" }}>
                  Próximo Passo{client.nextActionDate < today ? " — ATRASADO!" : ""}
                </div>
                <div style={{ fontSize: 12, color: client.nextActionDate < today ? "#7f1d1d" : "#115e59", marginTop: 3 }}>
                  {client.nextAction} — {fmtDate(client.nextActionDate)}
                </div>
              </div>
            )}

            {/* Loss reason */}
            {client.lossReason && (
              <div style={{ padding: "10px 14px", borderRadius: 8, background: "#fef2f2", border: "1px solid #fecaca", marginBottom: 14, fontSize: 12, color: "#991b1b" }}>
                <strong>Motivo da perda:</strong> {client.lossReason}
              </div>
            )}

            {/* Notes */}
            {client.notes && (
              <div style={{ padding: "10px 14px", borderRadius: 8, background: "#fffbeb", border: "1px solid #fde68a", fontSize: 12, color: "#78350f", lineHeight: 1.4, marginBottom: 14 }}>
                <strong>Observações:</strong> {client.notes}
              </div>
            )}

            {/* Histórico unificado (estágios + contatos) */}
            {/* Onde o contrato vira uso de verdade. A distância entre assinar
                e estar ativo é onde a receita fica parada. */}
            <div style={{ marginBottom: 14 }}>
              <AtivacaoNosModulos cliente={client} setClients={setClients} onAbrirAdesao={onAdesao ? () => { onClose(); onAdesao(client); } : null} />
            </div>

            <div style={{ marginBottom: 14 }}>
              <HistoryTimeline
                stageHistory={client.stageHistory} interactions={client.interactions} stageList={CLIENT_STAGES}
                onEditContato={(ref, patch) => setClients((prev) => prev.map((c) => (c.id === client.id ? corrigirContato(c, ref, patch, userName) : c)))}
              />
            </div>

            {/* Quick actions */}
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              <button onClick={() => setShowNewInteraction({ type: "client", id: client.id })} style={{ padding: "7px 12px", borderRadius: 6, border: "none", background: "#0d9488", color: "#fff", fontSize: 11, fontWeight: 600, cursor: "pointer" }}>
                + Registrar Contato
              </button>
              <button onClick={() => { handleStageChange("ganho"); onClose(); }} style={{ padding: "7px 12px", borderRadius: 6, border: "none", background: "#059669", color: "#fff", fontSize: 11, fontWeight: 600, cursor: "pointer" }}>
                ✓ Ganho
              </button>
              <button onClick={() => setShowLossModal(true)} style={{ padding: "7px 12px", borderRadius: 6, border: "none", background: "#ef4444", color: "#fff", fontSize: 11, fontWeight: 600, cursor: "pointer" }}>
                ✕ Perdido
              </button>
            </div>

            {/* ── PÓS-VENDA (only for won clients) ── */}
            {client.stage === "ganho" && (
              <div style={{ marginTop: 18, borderTop: "2px solid #059669", paddingTop: 14 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#059669", marginBottom: 10 }}>
                  Resumo Pós-Venda
                </div>

                {/* Contracts */}
                {(() => {
                  const clientContracts = (contracts || []).filter((c) => c.clientId === client.id);
                  const activeContracts = clientContracts.filter((c) => c.status === "ativo");
                  const totalMRR = activeContracts.reduce((s, c) => s + (parseFloat(c.value) || 0), 0);
                  return (
                    <div style={{ marginBottom: 10 }}>
                      <div style={{ fontSize: 11, fontWeight: 600, color: "#0f172a", marginBottom: 6 }}>Contratos</div>
                      {clientContracts.length === 0 ? (
                        <div style={{ fontSize: 11, color: "#94a3b8", padding: "6px 0" }}>Nenhum contrato registrado</div>
                      ) : (
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6, marginBottom: 6 }}>
                          <div style={{ padding: 8, borderRadius: 6, background: "#f0fdfa", textAlign: "center" }}>
                            <div style={{ fontSize: 10, color: "#64748b" }}>Contratos</div>
                            <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>{clientContracts.length}</div>
                          </div>
                          <div style={{ padding: 8, borderRadius: 6, background: "#f0fdfa", textAlign: "center" }}>
                            <div style={{ fontSize: 10, color: "#64748b" }}>Ativos</div>
                            <div style={{ fontSize: 14, fontWeight: 700, color: "#059669" }}>{activeContracts.length}</div>
                          </div>
                          <div style={{ padding: 8, borderRadius: 6, background: "#f0fdfa", textAlign: "center" }}>
                            <div style={{ fontSize: 10, color: "#64748b" }}>Receita/Mês</div>
                            <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>{fmt(totalMRR)}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })()}

                {/* Satisfaction */}
                {(() => {
                  const clientSat = (satisfaction || []).filter((s) => s.clientId === client.id);
                  const avg = clientSat.length > 0
                    ? (clientSat.reduce((s, r) => s + (r.score || 0), 0) / clientSat.length).toFixed(1)
                    : null;
                  const lastSurvey = clientSat.sort((a, b) => (b.surveyDate || "").localeCompare(a.surveyDate || ""))[0];
                  return (
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: "#0f172a", marginBottom: 6 }}>Satisfação / NPS</div>
                      {clientSat.length === 0 ? (
                        <div style={{ fontSize: 11, color: "#94a3b8", padding: "6px 0" }}>Nenhuma pesquisa registrada</div>
                      ) : (
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6 }}>
                          <div style={{ padding: 8, borderRadius: 6, background: "#f8fafc", textAlign: "center" }}>
                            <div style={{ fontSize: 10, color: "#64748b" }}>Pesquisas</div>
                            <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>{clientSat.length}</div>
                          </div>
                          <div style={{ padding: 8, borderRadius: 6, background: "#f8fafc", textAlign: "center" }}>
                            <div style={{ fontSize: 10, color: "#64748b" }}>Nota Média</div>
                            <div style={{ fontSize: 14, fontWeight: 700, color: avg >= 9 ? "#059669" : avg >= 7 ? "#f59e0b" : "#ef4444" }}>{avg}</div>
                          </div>
                          <div style={{ padding: 8, borderRadius: 6, background: "#f8fafc", textAlign: "center" }}>
                            <div style={{ fontSize: 10, color: "#64748b" }}>Última</div>
                            <div style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}>{lastSurvey ? fmtShort(lastSurvey.surveyDate) : "—"}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
            )}
          </div>
        )}
      </Modal>

      {/* Loss Reason Modal */}
      <Modal open={showLossModal} onClose={() => setShowLossModal(false)} title="Registrar Perda — Motivo" w={420}>
        <div style={{ marginBottom: 12, fontSize: 12, color: "#64748b" }}>
          Selecione o motivo principal da perda deste lead. Isso ajuda a melhorar abordagens futuras.
        </div>
        <Field label="Motivo da Perda" required>
          <select style={selectStyle} value={lossReason} onChange={(e) => setLossReason(e.target.value)}>
            <option value="">Selecione...</option>
            {LOSS_REASONS.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </Field>
        {lossReason === "Outro" && (
          <Field label="Descreva o motivo" required>
            <input style={inputStyle} value={lossOther} onChange={(e) => setLossOther(e.target.value)} placeholder="Descreva o motivo..." />
          </Field>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 6, marginTop: 8 }}>
          <button onClick={() => setShowLossModal(false)} style={{ padding: "7px 14px", borderRadius: 6, border: "1px solid #e2e8f0", background: "#fff", color: "#64748b", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Cancelar</button>
          <button onClick={handleLoss} disabled={!lossReason || (lossReason === "Outro" && !lossOther)} style={{ padding: "7px 14px", borderRadius: 6, border: "none", background: "#ef4444", color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer", opacity: (!lossReason || (lossReason === "Outro" && !lossOther)) ? 0.5 : 1 }}>
            Registrar Perda
          </button>
        </div>
      </Modal>

      {/* Delete Confirm */}
      <ConfirmDialog
        open={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
        onConfirm={() => { onDelete(client.id); onClose(); }}
        title="Excluir Cliente"
        message={`Tem certeza que deseja excluir "${client.company}"? Essa ação não pode ser desfeita.`}
        confirmLabel="Excluir"
        danger
      />
    </>
  );
}
